/* eslint-disable import/no-unresolved */
import createAction from 'helpers/createAction';

import {
  CHART_SUBSCRIPTION_PAYLOAD,
  MARK_PRICE_CHART_UPDATE,
  TOGGLE_FULL_SCREEN_MODE,
  SET_CHART_ACTIVE_TAB,
  SET_CHART_SCROLLING,
  SET_CHART_FROZEN,
  TOGGLE_PLACE_ORDER_SECTION,
  SET_CHART_COUNT,
  SET_CLOSE_POSITION_POPUP,
} from '../actionTypes/tradingView';

export const updateMarkPriceChart = createAction(MARK_PRICE_CHART_UPDATE);
export const addChartSubscriptionPayload = createAction(CHART_SUBSCRIPTION_PAYLOAD);
export const toggleFullScreenMode = createAction(TOGGLE_FULL_SCREEN_MODE);
export const setChartActiveTab = createAction(SET_CHART_ACTIVE_TAB);
export const setIsChartScrolling = createAction(SET_CHART_SCROLLING);
export const setIsChartFrozen = createAction(SET_CHART_FROZEN);
export const togglePlaceOrderSection = createAction(TOGGLE_PLACE_ORDER_SECTION);
export const setChartCount = createAction(SET_CHART_COUNT);
export const setShowClosePositionPopup = createAction(SET_CLOSE_POSITION_POPUP);
